import { keyframes } from "@emotion/react";
var circleAnimation = keyframes({
    ' 0%': {
        transform: 'rotateZ(0deg)'
    },
    '66%': {
        transform: 'rotateZ(220deg)'
    },
    '100%': {
        transform: 'rotateZ(360deg)'
    }
});
var sTailChaserAnimation = keyframes({
    '0%': {
        strokeDashoffset: 26,
        transform: 'rotateZ(0deg)'
    },
    '50%': {
        strokeDashoffset: 6,
        transform: 'rotateZ(45deg)'
    },
    '100%': {
        strokeDashoffset: 26,
        transform: 'rotateZ(360deg)'
    }
});
var mTailChaserAnimation = keyframes({
    '0%': {
        strokeDashoffset: 40,
        transform: 'rotateZ(0deg)'
    },
    '50%': {
        strokeDashoffset: 3,
        transform: 'rotateZ(45deg)'
    },
    '100%': {
        strokeDashoffset: 40,
        transform: 'rotateZ(360deg)'
    }
});
var lTailChaserAnimation = keyframes({
    '0%': {
        strokeDashoffset: 48,
        transform: 'rotateZ(0deg)'
    },
    '50%': {
        strokeDashoffset: 2,
        transform: 'rotateZ(45deg)'
    },
    '100%': {
        strokeDashoffset: 48,
        transform: 'rotateZ(360deg)'
    }
});
export var getStyle = function(theme) {
    var defaultColors = {
        gradientColor1: theme.backgroundColor.tertiary.fill.base,
        gradientColor2: theme.backgroundColor.brand.fill.focus,
        gradientColor3: theme.backgroundColor.accent.fill.base,
        rail: theme.backgroundColor.active
    };
    return {
        defaultColors: defaultColors,
        outerContainer: {
            base: {
                fontFamily: theme.font.base.family,
                fontSize: theme.font.base.size.h4,
                fontWeight: theme.font.base.weight.regular,
                position: 'relative',
                overflow: 'visible',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                transformOrigin: '50% 50%',
                flexGrow: 0,
                flexShrink: 0
            },
            big: {},
            inline: {
                flexDirection: 'row'
            }
        },
        circle: {
            base: {
                strokeDasharray: 45,
                animation: "".concat(circleAnimation, " 3.773s linear infinite"),
                transformOrigin: '50% 50%',
                overflow: 'visible',
                stroke: theme.backgroundColor.active,
                strokeLinecap: 'round',
                strokeWidth: '2px',
                marginBottom: theme.spacing[1],
                fill: 'transparent'
            },
            m: {
                width: theme.icon.size.m,
                height: theme.icon.size.m,
                strokeDasharray: 400
            },
            l: {
                width: theme.icon.size.l,
                height: theme.icon.size.l,
                strokeDasharray: 400
            },
            s: {
                width: theme.icon.size.s,
                height: theme.icon.size.s,
                strokeDasharray: 400
            },
            slow: {
                animation: "".concat(circleAnimation, " 37.73s linear infinite")
            }
        },
        tailChaser: {
            base: {
                transformOrigin: '50% 50%',
                strokeWidth: '2px',
                fill: 'transparent',
                strokeLinecap: 'round'
            },
            s: {
                animation: "".concat(sTailChaserAnimation, "  2.45s linear infinite"),
                strokeDasharray: 33
            },
            m: {
                strokeDasharray: 50,
                animation: "".concat(mTailChaserAnimation, "  2.45s linear infinite")
            },
            l: {
                strokeDasharray: 66,
                animation: "".concat(lTailChaserAnimation, "  2.45s linear infinite")
            }
        }
    };
};
